module.exports = __webpack_public_path__ + "img/precise_content.c394d332.png";